import {searchRegistry} from "../../platform/search/register/search-registry";
import {Laptop, FolderGit2, ChartColumnStacked, FolderClock} from "lucide-react";

searchRegistry.register([
    {
        id: "assets.dashboard",
        title: "Asset Tracker",
        description: "Manage Assets",
        route: "/asset/dashboard",
        category: "Administration",
        permissions: ["ADMIN"],
        tags: ["asset", "laptop", "gadgets"],
        type: 'quickLink',
        priority: 2,
        icon: Laptop
    },
    {
        id: "assets.categories",
        title: "Asset Category Setup",
        description: "Category Management",
        route: "/asset/category",
        category: "Administration",
        permissions: ["ADMIN"],
        tags: ["category", "assets"],
        icon: FolderGit2,
        type: 'result'
    },
    {
        id: "assets.allocate",
        title: "Allocate Asset",
        description: "Manage Asset Allocation",
        route: "/asset/allocation",
        category: "Administration",
        permissions: ["ADMIN"],
        tags: ["allocate", "assets"],
        icon: ChartColumnStacked
    },
]);
